import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'roleLabel',
  standalone: true
})
export class RoleLabelPipe implements PipeTransform {
  transform(value: string): string {
    if(value == 'User') {
      return 'IEA Parent/Guardian';
    }
    return value.replace(/([a-z])([A-Z])/g, '$1 $2');
  }
}
